import { NSARouterMakerResult } from 'namirasoft-account-react';
import { EncodingOperation } from 'namirasoft-core';
import { UserFullRow } from 'namirasoft-password';
import { EncryptionOperation, NSButtonBlue, NSPanel } from 'namirasoft-site-react';
import { Component, createRef } from 'react';
import PasswordForm from '../components/PasswordForm';
import { PasswordLayout } from '../PasswordLayout';
import { PasswordRouterProps } from '../PasswordRouterProps';
import { Storage } from '../Storage';

export interface PasswordChangePageProps extends NSARouterMakerResult, PasswordRouterProps
{
    user: UserFullRow;
    loadUser: () => Promise<void>;
}

export class PasswordChangePage extends Component<PasswordChangePageProps>
{
    private PasswordForm_Ref = createRef<PasswordForm>();
    constructor(props: PasswordChangePageProps)
    {
        super(props);
        this.changePassword = this.changePassword.bind(this);
    }

    async changePassword(onFinished: () => void)
    {
        let ciphered_master_key: string;
        try
        {
            let passwords = this.PasswordForm_Ref.current?.getPasswords();

            if (!passwords)
            {
                onFinished();
                return;
            }

            let encoded_current_password = EncodingOperation.Base64Encode(passwords.current);
            let master_key;
            try
            {
                master_key = await EncryptionOperation.AES256GCMDecrypt<string>(encoded_current_password, this.props.user.cipher);
            }
            catch
            {
                this.props.notifier.onError("Current password is incorrect.");
                onFinished();
                return;
            }

            let encoded_new_password = EncodingOperation.Base64Encode(passwords.password);
            ciphered_master_key = await EncryptionOperation.AES256GCMEncrypt(encoded_new_password, master_key);
        }
        catch (error)
        {
            // Local input/encryption errors are not reported by the server, so notify here.
            this.props.notifier.onError(error as Error);
            onFinished();
            return;
        }

        try
        {
            await this.props.servers.password.user.Set({ cipher: ciphered_master_key });
            this.props.notifier.onSuccess("Your password has been updated successfully.");
            await Storage.delMasterKey(this.props.user.id);
            Storage.delUser(this.props.user.id);
            await this.props.loadUser();
            this.props.url.redirect("/", {});
            onFinished();
        }
        catch
        {
            // The server already reported the error through the notifier.
            onFinished();
        }
    }

    override render()
    {
        return (
            <PasswordLayout
                {...this.props}
                action={{
                    title: "Change Master Password",
                    description: "Change your Master Password. You enter your current one, then set a new one, and your vault is encrypted again under it."
                }}
            >
                <NSPanel classList={["mx-auto"]}>
                    <PasswordForm
                        ref={this.PasswordForm_Ref}
                        {...this.props}
                        require_current_password
                    />
                    <NSButtonBlue
                        title={"Apply"}
                        onClick={{ action: this.changePassword }}
                    />
                </NSPanel>
            </PasswordLayout>
        )
    }
}

export default PasswordChangePage;